<template>
	<div class="copyable-value" v-clipboard:copy="String(value)" v-clipboard:success="onCopy">
		<span><slot>{{ value }}</slot></span>
		<slot name="after"></slot>
		<i class="copy-icon ion-ios-copy-outline"></i>
		<transition name="fade">
			<span v-if="copied" class="copied-tooltip">Copied</span>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'CopyableValue',
	props: {
		value: { type: [String, Number], required: true }
	},
	data() {
		return { copied: false }
	},
	methods: {
		onCopy() {
			this.copied = true
			setTimeout(() => { this.copied = false }, 1000)
		}
	}
}
</script>

<style scoped>
.copyable-value {
	display: inline-flex;
	align-items: center;
	position: relative;
	cursor: pointer;
	padding: 4px 8px;
	margin-left: -8px;
	border-radius: 6px;
	transition: background-color 0.15s ease;
}
.copyable-value:hover {
	background-color: #f3f4f6;
}

.copy-icon {
	margin-left: 8px;
	font-size: 0.85em;
}

.copied-tooltip {
	position: absolute;
	top: -28px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 0.75em;
	font-weight: 500;
	color: #fff;
	background-color: #1f2937;
	padding: 4px 8px;
	border-radius: 4px;
	white-space: nowrap;
}
.copied-tooltip::after {
	content: '';
	position: absolute;
	top: 100%;
	left: 50%;
	transform: translateX(-50%);
	border: 5px solid transparent;
	border-top-color: #1f2937;
}
</style>
